// @ts-nocheck
import { Routes, Route } from 'react-router-dom';
import ForgotOverview from './ForgotPasswordOverview';
// Renamed variants
import ForgotClassicMinimal from './ForgotClassicMinimal';
import ForgotHeroImage from './ForgotHeroImage';
import ForgotDarkMode from './ForgotDarkMode';
// Existing variants
import ForgotSplit from './ForgotSplit';
import ForgotGradient from './ForgotGradient';
import ForgotModern from './ForgotModern';
import ForgotAnimated from './ForgotAnimated';
import ForgotIllustrated from './ForgotIllustrated';
import ForgotParallax from './ForgotParallax';
import ForgotMinimal3D from './ForgotMinimal3D';
import ForgotSplitScreen from './ForgotSplitScreen';
// New variants
import ForgotCenteredCard from './ForgotCenteredCard';
import ForgotGlassmorphism from './ForgotGlassmorphism';
import ForgotMobileAppStyle from './ForgotMobileAppStyle';
import ForgotSocialLogin from './ForgotSocialLogin';
import ForgotSidebar from './ForgotSidebar';
import ForgotCarouselOnboarding from './ForgotCarouselOnboarding';

export default function ForgotRoutes() {
  return (
    <Routes>
      <Route index element={<ForgotOverview />} />
      {/* Renamed routes */}
      <Route path="classic-minimal" element={<ForgotClassicMinimal />} />
      <Route path="hero-image" element={<ForgotHeroImage />} />
      <Route path="dark-mode" element={<ForgotDarkMode />} />
      {/* Existing routes */}
      <Route path="split" element={<ForgotSplit />} />
      <Route path="gradient" element={<ForgotGradient />} />
      <Route path="modern" element={<ForgotModern />} />
      <Route path="animated" element={<ForgotAnimated />} />
      <Route path="illustrated" element={<ForgotIllustrated />} />
      <Route path="parallax" element={<ForgotParallax />} />
      <Route path="minimal3d" element={<ForgotMinimal3D />} />
      <Route path="splitscreen" element={<ForgotSplitScreen />} />
      {/* New routes */}
      <Route path="centered-card" element={<ForgotCenteredCard />} />
      <Route path="glassmorphism" element={<ForgotGlassmorphism />} />
      <Route path="mobile-app-style" element={<ForgotMobileAppStyle />} />
      <Route path="social-login" element={<ForgotSocialLogin />} />
      <Route path="sidebar" element={<ForgotSidebar />} />
      <Route path="carousel-onboarding" element={<ForgotCarouselOnboarding />} />
    </Routes>
  );
}
